import { render, staticRenderFns } from "./ModalAddCarrinhoPizza.vue?vue&type=template&id=aaab52bc&scoped=true"
import script from "./ModalAddCarrinhoPizza.vue?vue&type=script&lang=js"
export * from "./ModalAddCarrinhoPizza.vue?vue&type=script&lang=js"
import style0 from "./ModalAddCarrinhoPizza.vue?vue&type=style&index=0&id=aaab52bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaab52bc",
  null
  
)

export default component.exports